module.exports = __webpack_public_path__ + "img/714.e9ae4fd1.gif";